import type { VoiceCloneStatus } from '../types';

export const ICON_BASE = 'mt-[2px] size-[24px] shrink-0 rounded-full border-[3px]';

export const STEP_CLASS_MAP: Record<string, string> = {
  done: 'text-gray-600',
  active: 'font-medium text-dark-100',
  uploading: 'font-medium text-dark-100',
  error: 'font-medium text-red-500',
  skipped: 'text-gray-350',
};

export function stepClassName(status: string): string {
  return STEP_CLASS_MAP[status] ?? 'text-gray-350';
}

export function voiceCloneLabelText(status: VoiceCloneStatus): string {
  if (status === 'done') return 'Voice clone uploaded';
  if (status === 'error') return 'Voice clone failed';
  return 'Uploading voice clone...';
}
